import { Text, View } from "@/components";
import cn from "@/utils/cn";

import type { InputsProps } from "@/components/types";
import type { JSX } from "react";

const InputTextarea = ({
  children,
  id,
  label,
  className = "",
  type: _type,
  ...props
}: InputsProps): JSX.Element => (
  <View className="w-full">
    {label && (
      <Text type="label" htmlFor={id} className="font-medium block mb-4">
        {label}
      </Text>
    )}
    <View className={cn(className, "w-full border rounded-3xl px-6 py-3")}>
      <Text
        id={id}
        type="textarea"
        className="w-full text-sm focus:outline-none bg-transparent resize-none overflow-y-auto custom-scrollbar"
        {...props}
      >
        {children}
      </Text>
    </View>
  </View>
);

export default InputTextarea;
